import { hotWorks } from '@/mocks/gallery';

export default function HotWorks() {
  return (
    <section id="hot" className="relative w-full scroll-mt-16 bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-2">
          <span className="text-sm font-medium uppercase tracking-widest text-accent-500">Popular Now</span>
          <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-4xl">本周热门作品</h2>
          <p className="max-w-2xl text-sm text-foreground-300 md:text-base">
            收藏与点赞最多的同人大图，每一张都值得用来做壁纸。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {hotWorks.map((work) => (
            <article
              key={work.id}
              className="group overflow-hidden rounded-lg bg-background-100 ring-1 ring-background-200/60 transition-colors hover:ring-primary-500/50"
            >
              <div className="relative overflow-hidden">
                <img
                  src={work.image}
                  alt={`${work.title} 热门娜美同人壁纸`}
                  title={`${work.title} 热门同人插画`}
                  className="aspect-[3/2] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-transparent to-transparent"></div>
                <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  HOT
                </span>
                <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-full bg-background-50/70 px-2.5 py-1 text-xs text-foreground-200 backdrop-blur-sm">
                  <i className="ri-heart-3-fill text-accent-500"></i>
                  {work.likes.toLocaleString()}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-50">{work.title}</h3>
                <p className="mt-1 text-xs text-foreground-400">
                  {work.style} · {work.artist}
                </p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{work.updated}</span>
                  <button
                    type="button"
                    className="flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
                  >
                    <i className="ri-download-2-line text-sm"></i>下载
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}